import React, { useContext, useEffect, useState } from "react";
import styles from "./ProgressPopup.module.css";
import closebutton from "../../assests/closebutton.svg";
import ContactUsFooter from "../ContactUsFooter/ContactUsFooter";
import Context from "../../context/Context";
import loadingAnimation from "../../assests/loading.json";
import { useNavigate } from "react-router";
import { isEmpty } from "lodash";
import Lottie from "react-lottie-player";

export default function ProgressPopup({ setPopup, data, getProgress }) {
  const [show, setShow] = useState(false);
  const [nonParticipatedContest, setNotParticipatedContest] = useState([]);
  const [loading, setLoading] = useState(true);
  const { details } = useContext(Context);
  useEffect(() => {
    setShow(true);
  }, []);
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  useEffect(() => {
    const laodProgress = async () => {
      setLoading(true);
      await getProgress(details?.orgId, details?.campaignId);
      setLoading(false);
    };
    laodProgress();
  }, []);
  useEffect(() => {
    if (!isEmpty(data)) {
      let quizContest = details?.contests?.filter((contest) =>
        contest?.contestType?.startsWith("QUIZ")
      );
      const remainingContests = quizContest?.filter((contest) => {
        return !data?.participatedContests?.some(
          (participatedItem) =>
            participatedItem?.contestId === contest?.contestId
        );
      });
      setNotParticipatedContest(remainingContests);
    }
  }, [data]);
  const navigate = useNavigate();
  const profileHelpNavigate = () => {
    navigate(`/profile/help`);
  };

  return (
    <div className={styles.popupWrapper}>
      <div
        className={`h-full w-full bg-black bg-opacity-40 max-w-[425px] mx-auto pt-[50px] backdrop-blur-sm transform transition-transform ease-in-out duration-300
      ${show ? "translate-y-0" : "translate-y-full"}
      `}
      >
        {" "}
        <div className={`no-scrollbar ${styles.parentDiv}`}>
          <div className="flex justify-between items-center w-[100%]  sticky top-0 left-0 bg-black ">
            <p className="text-large-bold p-[20px]">Progress</p>
            <img
              src={closebutton}
              onClick={() => setPopup(false)}
              className=" hover:cursor-pointer p-[20px]"
            />
          </div>
          {loading ? (
            <div className="w-[100vw] max-w-[425px] flex align-center justify-center">
              <Lottie
                loop
                animationData={loadingAnimation}
                play
                style={{ width: 200, height: 100 }}
              />
            </div>
          ) : (
            <div className="p-[20px]">
              {isEmpty(data?.participatedContests) ? (
                <p
                  className="text-center my-[16px] p-[5px] rounded-[16px] text-black text-small-bold"
                  style={{
                    background: details?.bgColor || "#F6E7D8",
                  }}
                >
                  Participate in contest to see progress
                </p>
              ) : (
                <table className={styles.table}>
                  <thead>
                    <tr>
                      <th className="text-regular-bold">Contest Name</th>
                      <th className="text-regular-bold">Marks Obtained</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.participatedContests?.map((obj, index) => (
                      <tr key={index}>
                        <td className="text-small">{obj?.contestName}</td>
                        <td
                          className={`text-small ${
                            obj?.status == "EDITED" &&
                            "backdrop-blur-lg bg-white/30 opacity-50"
                          }`}
                        >
                          {obj?.status == "EDITED" && (
                            <span>Mark obtained is </span>
                          )}
                          {obj?.quizMarksObtained}
                          {obj?.status == "EDITED" && (
                            <span> and waiting for admin approval</span>
                          )}
                        </td>
                      </tr>
                    ))}
                    {nonParticipatedContest?.map((obj, index) => (
                      <tr key={index}>
                        <td className="text-small">{obj?.contestName}</td>
                        <td className="text-small relative backdrop-blur-lg bg-white/30 opacity-50 text-right">
                          Not Participated
                        </td>
                      </tr>
                    ))}
                    {!(
                      data?.totalMarksObtained == null ||
                      data?.totalMarksObtained == undefined
                    ) && (
                      <tr>
                        <td className="text-small-bold">Total</td>
                        <td className="text-small-bold">
                          {data?.totalMarksObtained}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
              {data?.cutOffMarks && (
                <p
                  className="text-center my-[16px] p-[5px] rounded-[16px] text-black text-small-bold"
                  style={{
                    background: details?.bgColor || "#F6E7D8",
                  }}
                >
                  {data?.cutOffMarks
                    ? `You only need a total of ${data?.cutOffMarks} marks to qualify`
                    : `The cutoff mark hasn't been added yet.`}
                </p>
              )}
              {data?.cutOffMarksText && (
                <p
                  className="text-center my-[16px] p-[5px] rounded-[16px] text-black text-small-bold"
                  style={{
                    background: details?.bgColor || "#F6E7D8",
                  }}
                >
                  {data?.cutOffMarksText}
                </p>
              )}
            </div>
          )}
          <div className="seperator mt-[30px]" />
          <ContactUsFooter profileHelpNavigate={profileHelpNavigate} />
        </div>
      </div>
    </div>
  );
}
